import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Maintenance, MaintenanceType, MaintenanceStatus, Priority } from '../../models/maintenance';

@Component({
    selector: 'app-maintenance-detail-dialog',
    templateUrl: './maintenance-detail-dialog.component.html',
    styleUrls: ['./maintenance-detail-dialog.component.css']
})
export class MaintenanceDetailDialogComponent implements OnInit {

    maintenance: Maintenance;

    constructor(
        public dialogRef: MatDialogRef<MaintenanceDetailDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.maintenance = data.maintenance;
    }

    ngOnInit(): void {
    }

    close(): void {
        this.dialogRef.close();
    }

    print(): void {
        window.print();
    }

    getStatusColor(status: MaintenanceStatus): string {
        const colors: { [key: string]: string } = {
            'demande': 'gray',
            'planifiee': 'blue',
            'en_cours': 'orange',
            'terminee': 'green',
            'annulee': 'red',
            'reportee': 'yellow',
            'en_attente_fournisseur': 'purple'
        };
        return colors[status] || 'gray';
    }

    getPriorityColor(priority: Priority): string {
        const colors: { [key: string]: string } = {
            'basse': 'gray',
            'normale': 'blue',
            'haute': 'orange',
            'urgence': 'red'
        };
        return colors[priority] || 'gray';
    }

    getTypeLabel(type: MaintenanceType): string {
        const labels: { [key: string]: string } = {
            'reparation': 'Réparation',
            'entretien': 'Entretien',
            'renovation': 'Rénovation',
            'inspection': 'Inspection',
            'urgence': 'Urgence',
            'maintenance_preventive': 'Maintenance Préventive'
        };
        return labels[type] || type;
    }

    formatPrice(price?: number): string {
        if (!price) return '0 FCFA';
        return new Intl.NumberFormat('fr-FR', {
            style: 'currency',
            currency: 'XOF'
        }).format(price);
    }

    formatDate(date?: Date): string {
        if (!date) return '-';
        return new Date(date).toLocaleDateString('fr-FR');
    }
}
